import { getId } from '@fluentui/react/lib/Utilities';

export function createComposeFormId(): string {
    return getId('CalendarCompose_');
}
